import { action, observable, runInAction, makeObservable } from 'mobx';
import { request } from '@/framework/network/request'
import Role from '../model/Role'
import Resource from '../model/Resource'
import Platform from '../model/Platform'

export default class RoleStore {
  loading: boolean; // list loading
  editing: boolean; // edit drawer show
  saving: boolean; // role saving

  list: Array<Role>;
  search: any;
  pagination: any;
  role: Role;

  platforms: Platform[];
  resources: { [key: string]: Resource[] };

  constructor () {
    makeObservable(this, {
      loading: observable,
      editing: observable,
      saving: observable,
      list: observable,
      search: observable,
      pagination: observable,
      role: observable,
      platforms: observable,
      resources: observable,
      fetchList: action,
      fetchResources: action,
      fetchRole: action,
      saveRole: action,
      del: action,
      showForm: action,
      hideForm: action
    });

    this.loading = false
    this.editing = false
    this.saving = false

    this.list = []
    this.search = {}
    this.pagination = {
      pageSizeOptions: ['2', '10', '20', '30', '50'],
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total: string) => `共 ${total} 条记录`
    }
    this.role = new Role()

    this.platforms = []
    this.resources = {}
  }

  /**
   * 获取角色列表
   * @param page
   * @param size
   * @param search
   */
  fetchList = async (page = 0, size = 10, search: any = {}) => {
    runInAction(() => {
      this.loading = true
    })
    const res = await request.get(`/u/roles:search`, { ...search, page, size })
    runInAction(() => {
      this.search = search
      this.list = res.data.content
      this.pagination = {
        ...this.pagination,
        total: res.data.totalElements,
        current: res.data.number + 1,
        pageSize: res.data.size,
      }
      this.loading = false
    })
  };

  /**
   * 获取平台列表
   * 分平台获取资源列表
   */
  fetchResources = async () => {
    const res = await request.get(`/u/platforms`)
    const resources: { [key: string]: Resource[] } = {} // 所有平台的所有权限
    for (let i = 0; i < res.data.length; i++) {
      const resourceArray = await request.get(`/u/role/permissions/platformId/${res.data[i].id}`)
      resources[res.data[i].mark!] = resourceArray.data
    }
    runInAction(() => {
      this.platforms = res.data
      this.resources = resources
    })
  };

  /**
   * 获取角色
   * @param id 角色id
   */
  fetchRole = async (id?: number) => {
    this.loading = true
    if (id) {
      const res = await request.get(`/u/role/${id}/permission`)
      runInAction(() => {
        this.role = {
          ...res.data,
        }
        this.loading = false
      })
    } else {
      runInAction(() => {
        this.role = new Role()
        this.loading = false
      })
    }
  };

  /**
   * 保存角色
   * @param role
   */
  saveRole = async (role: Role) => {
    this.loading = true
    if (role.id) {
      await request.put(`/u/role/${role.id}`, role)
    } else {
      await request.post(`/u/role`, role)
    }
    const { current, pageSize } = this.pagination
    await this.fetchList(current - 1, pageSize, this.search)
    runInAction(() => {
      this.editing = false
    })
  };

  /**
   * 删除角色
   * @param id
   */
  del = async (id: number) => {
    await request.delete(`/u/role/${id}`)
    const { current, pageSize } = this.pagination
    await this.fetchList(current - 1, pageSize, this.search)
  };

  showForm = () => {
    this.editing = true
  };

  hideForm = () => {
    this.editing = false
  };
}
